module.exports = __webpack_public_path__ + "static/media/28.88a6e778.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/28.jpg
// module id = 718
// module chunks = 0